module.exports = __webpack_public_path__ + "static/media/PCD224C.a2b4ed10.png";